import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { object, string } from 'yup';
import { SecurityDetailsTextField } from '../atomic-components/SecurityDetailsTextField';

export const validationSchemaSecurityInformation = object({
  securityDetails: string().required('Location description is required'),
});

interface Props {
  disabled: boolean;
}

export const SecurityInformation: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  return (
    <LaunchpadCard title={t('dashboard.assets.addedit.investment.securityinformation.title')}>
      <SecurityDetailsTextField disabled={disabled} />
    </LaunchpadCard>
  );
};
